import LearnerProgressDashboard from '../components/learner-progress-dashboard';

/* @ngInject */
export default function LearnerProgressDashboardCtrl(
  $scope,
) {
  $scope.LearnerProgressDashboard = LearnerProgressDashboard;
}
